import { Property } from './property';
import { User } from './user';
import { PurchaseUserDetails } from './purchase-user-details';

export type PURCHASE_STATUS = 'pending' | 'awaiting payment' | 'awaiting confirmation' | 'paid' | 'cancelled';
export enum PURCHASE_STATUS_ENUM {
  pending = 'pending',
  awaitingPayment = 'awaiting payment',
  awaitingConfirmation = 'awaiting confirmation',
  paid = 'paid',
  cancelled = 'cancelled',
}

export interface Purchase {
  id: string;
  property: Property;
  user: User;
  amount: number;
  paid: number;
  status: PURCHASE_STATUS;
  dueOn: Date;
  userDetails: PurchaseUserDetails;
  createdAt: Date;
  updatedAt: Date;
}